import * as React from "react";
const SvgFiRrCircleA = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-a_svg__a)">
      <path
        fill="#062147"
        d="M14.492 7.116c-.405-.97-1.368-1.597-2.453-1.597A2.65 2.65 0 0 0 9.57 7.156l-3.22 8.768a.999.999 0 1 0 1.877.689l.861-2.345h5.901l.861 2.345a1 1 0 1 0 1.877-.69l-3.235-8.808m-4.67 5.153 1.61-4.383c.141-.341.5-.367.606-.367s.465.026.592.327l1.624 4.423zM12.04.019c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.384-12-12-12m0 22c-5.514 0-10-4.486-10-10s4.485-10 10-10 10 4.486 10 10-4.486 10-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-a_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleA;
